module.exports = __webpack_public_path__ + "img/icon_map_0_off_111.af2e39e4.png";